(() => {
  const sections = document.querySelectorAll('.hero[id^="hero-"]');
  if (!sections.length) return;

  sections.forEach(section => {
    const track = section.querySelector('.hero__track');
    const slides = Array.from(section.querySelectorAll('.hero__slide'));
    const dots   = Array.from(section.querySelectorAll('.hero__dot'));
    if (!track || !slides.length || !dots.length) return;

    // ---- helpers
    const setSelected = (i) => {
      dots.forEach((d,idx) => d.setAttribute('aria-selected', String(idx === i)));
      // met aria-current sur le slide
      slides.forEach((s,idx) => s.setAttribute('aria-current', idx === i ? 'true' : 'false'));
    };

    // Compute the absolute scrollLeft needed to align the slide with the track
    const getTargetLeft = (idx) => {
      const slideRect = slides[idx].getBoundingClientRect();
      const trackRect = track.getBoundingClientRect();
      // current scroll + delta between slide and track in viewport coords
      return track.scrollLeft + (slideRect.left - trackRect.left);
    };

    const goTo = (i) => {
      const index = Math.max(0, Math.min(i, slides.length - 1));
      const left = getTargetLeft(index);
      try {
        track.scrollTo({ left, behavior: 'smooth' });
      } catch (e) {
        // Fallback for very old browsers
        track.scrollLeft = left;
      }
      setSelected(index);
      current = index;
    };

    // Calcule l'index le plus proche du scroll actuel (raf-throttle)
    let ticking = false, current = 0;
    const onScroll = () => {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(() => {
        const left = track.scrollLeft;
        let nearest = 0, best = Infinity;
        for (let i=0; i<slides.length; i++){
          const delta = Math.abs(slides[i].offsetLeft - left);
          if (delta < best){ best = delta; nearest = i; }
        }
        if (nearest !== current){
          current = nearest;
          setSelected(current);
        }
        ticking = false;
      });
    };
    track.addEventListener('scroll', onScroll, { passive: true });

    // Dots click
    dots.forEach(btn => {
      btn.addEventListener('click', () => {
        const i = parseInt(btn.getAttribute('data-index'), 10) || 0;
        goTo(i);
        pauseAutoplayTemporarily();
      });
    });

    // Keep alignment on resize/orientation change
    const onResize = () => { goTo(current); };
    window.addEventListener('resize', onResize);
    window.addEventListener('orientationchange', onResize);

    // ---- autoplay
    const autoplay = section.dataset.autoplay === 'true';
    const interval = Number(section.dataset.interval || 5000);
    let timer = null, paused = false;

    const next = () => {
      const target = (current + 1) % slides.length; // boucle
      goTo(target);
    };

    const start = () => {
      if (!autoplay || paused) return;
      stop();
      timer = setInterval(next, interval);
    };
    const stop = () => { if (timer) { clearInterval(timer); timer = null; } };
    let resumeTO;
    const pauseAutoplayTemporarily = () => {
      paused = true; stop();
      // reprend automatiquement après une petite inactivité
      window.clearTimeout(resumeTO);
      resumeTO = window.setTimeout(() => { paused = false; start(); }, Math.min(interval, 4000));
    };

    // pause au survol / interaction / changement d’onglet
    ['pointerdown','touchstart','mouseenter','keydown'].forEach(evt => {
      section.addEventListener(evt, pauseAutoplayTemporarily, { passive: true });
    });
    document.addEventListener('visibilitychange', () => {
      if (document.hidden) stop(); else start();
    });

    // init
    setSelected(0);
    start();
  });
})();
